module.exports = __webpack_public_path__ + "kt-kitty.json";